import {
    ApplicationRef,
    ComponentFactoryResolver,
    ComponentRef,
    EmbeddedViewRef,
    Injectable,
    Injector,
    Type,
} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DomService {
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector,
    ) {}

    public appendComponentToBody<T, V>(
        component: Type<T>,
        componentInput?: V,
        customInjector?: Injector,
        projectableNodes?: any[][],
    ): ComponentRef<T> {
        const componentRef: ComponentRef<T> = this.componentFactoryResolver
            .resolveComponentFactory<T>(component)
            .create(customInjector ? customInjector : this.injector, projectableNodes);
        if (componentInput) {
            Object.keys(componentInput).forEach((key) => {
                componentRef.instance[key] = componentInput[key];
            });
        }
        this.appRef.attachView(componentRef.hostView);
        const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);
        return componentRef;
    }

    public removeComponentFromBody<T>(componentRef: ComponentRef<T>) {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
}
